export enum EWatchlistCategory {
  TOP_PICK = 'TOP_PICK',
  TOP_GAINER = 'TOP_GAINER',
  TOP_LOSER = 'TOP_LOSER',
  FAVOURITES = 'MY_WATCHLIST',
  ALL = 'ALL',
  POPULAR = 'POPULAR'
}

// Watchlist APIs params
export interface IGetWatchlistParams {
  code: EWatchlistCategory;
  abortable?: boolean;
}

export interface IFavouriteWatchlistParams {
  symbol: string;
}
